import './public-path';
import './utils/patchResizeObserver';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, Spin } from 'antd';
import routes from './routes';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import '@/assets/css/main.scss';
import './base.scss';
import zhCN from 'antd/lib/locale/zh_CN';
import dayjs from 'dayjs';
dayjs.locale('zh-cn');

const rootNode = document.getElementById('app')!;
const root = ReactDOM.createRoot(rootNode);
const height = window.innerHeight / 2;

const App: React.FC = () => {
  console.log('======111====');
  const routing = useRoutes(routes);
  return <ConfigProvider locale={zhCN}>{routing}</ConfigProvider>;
};

root.render(
  <React.Suspense
    fallback={
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: `${height}px`,
        }}
      >
        <Spin />
      </div>
    }
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Suspense>
);

/**
 * micro-app 子应用卸载/隐藏时清理 body 上的 portal 元素
 * Popconfirm、Tooltip、Modal 等 antd 组件通过 Portal 挂载到 document.body
 * micro-app 卸载时不会自动清理这些外部 DOM，导致切换页面后确认框仍然残留显示
 */
const cleanupMicroAppPortals = () => {
  // 清理 CommonModal 创建的 DOM
  const commonModal = document.getElementById('commonModal');
  if (commonModal) {
    commonModal.remove();
  }
  // 清理 antd Popconfirm、Tooltip 等 portal 元素
  document.querySelectorAll('.ant-popover, .ant-tooltip').forEach((el) => {
    el.remove();
  });
};

// 监听 micro-app 卸载事件
if ((window as any).__MICRO_APP_ENVIRONMENT__) {
  window.addEventListener('unmount', cleanupMicroAppPortals);
}
